import { Route } from 'src/routes/Route'

export const PointsConversionRoute = Route({ path: '/points-conversion' })
export type PointsConversionRoute = Route<typeof PointsConversionRoute>
